import Validator from './Validator'

class ITvalidator extends Validator {
  pznMaxLength = 12
  pznMinNumericLength = 8

  // Adds maximum one zero
  padWithLeadingZero(digitsString) {
    const toBePadded = digitsString.replace(/^0+/, '')

    return toBePadded.padStart(
      Math.min(this.pznMinNumericLength, toBePadded.length + 1),
      '0'
    )
  }
}

export default ITvalidator
